<template>
  <div id="EyeType_Setting">
    <br />
    <el-row>
      <el-col :span="3"> {{ $t("langcfg.txtEyeType") }}: </el-col>
      <el-col :span="20" style="margin-left: -35px">
        <el-radio-group v-model="selEyeType" text-color="#00ff00">
          <el-radio
            v-for="item in allEyeTypes"
            :label="item.value"
            text-color="#00ff00"
            @change="selectEye"
            :key="item.value"
          >
            {{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { saveCaptureSettings, getCaptureSettings } from "../../../settings";
import { isDefined } from "../../../shared/utils";
export default {
  name: "EyeTypeSetting",
  data() {
    return {
      allEyeTypes: [
        { value: 0, label: this.$t("langcfg.txtHumanEye") },
        { value: 1, label: this.$t("langcfg.txtModelEye") }
      ],
      selEyeType: 0
    };
  },
  mounted() {
    const originCaptureSettings = getCaptureSettings();
    if (isDefined(originCaptureSettings.EyeMaterial) && originCaptureSettings.EyeMaterial === 1) {
      Object.assign(originCaptureSettings, { EyeMaterial: 0 });
      saveCaptureSettings(originCaptureSettings);
    } else {
      this.selEyeType = window.captureSettings.EyeMaterial;
    }
  },
  methods: {
    selectEye() {
      window.captureSettings.EyeMaterial = this.selEyeType;
      this.$bus.$emit(EVENTS.changeEyeMaterial);
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
#EyeType_Setting {
  margin-left: 40px;
  text-align: left;
}

.el-radio {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: -5px !important;
}
.el-radio-group /deep/ label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/EyeTypeSetting.vue